import styled from 'styled-components';

export const ContainerModal = styled.div`
  padding: 40px 40px 5px 40px;
  min-height: 570px;
`;
